import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Dropdown, Tooltip } from 'antd';
import { VerticalAlignBottomOutlined } from '@ant-design/icons';
import { downloadOrNotify } from 'components/massive/download';
import { downloadLabelWithFallback } from 'services/ShipmentSegaService';

const DownloadLabelButton = ({ packageId, externalCode, marketplaceId }) => {
  const [loading, setLoading] = useState(false);

  const download = async (format) => {
    setLoading(true);
    await downloadOrNotify(
      () =>
        downloadLabelWithFallback(
          packageId,
          externalCode,
          format,
          marketplaceId,
        ),
      `Etiqueta-${externalCode}.${format}`,
    );
    setLoading(false);
  };

  const items = [
    {
      key: 'pdf',
      label: 'Etiqueta en PDF',
      onClick: () => download('pdf'),
    },
    {
      key: 'zpl',
      label: 'Etiqueta en ZPL',
      onClick: () => download('zpl'),
    },
  ];

  return (
    <Tooltip title="Imprimir etiqueta">
      <Dropdown menu={{ items }} trigger={['click']} placement="bottomRight">
        <Button
          type="primary"
          loading={loading}
          icon={<VerticalAlignBottomOutlined />}
        />
      </Dropdown>
    </Tooltip>
  );
};

DownloadLabelButton.propTypes = {
  packageId: PropTypes.number.isRequired,
  externalCode: PropTypes.string.isRequired,
  marketplaceId: PropTypes.number,
};

DownloadLabelButton.defaultProps = {
  marketplaceId: undefined,
};

export default DownloadLabelButton;
